/**
 *  Author: lanwei@cloudybay.com.tw
 */


(function (window, document, undefined) {

//
// The is GeoJsonLayer extend by ShellLayer,
// that could load geojson data after add to map.
//
L.GeoJsonLayer = L.ShellLayer.extend({
    initialize: function(options) {
        this._layer = null;
        this._map = null;
        this.options = options || {};
        this.__load();
    },

    __load: function() {
        var self = this;

        if (self.options.src) {
            let _options = {
                style: self.options.style,
                clickable: false,
                pane: self.options.pane
            };
            if (self.options.renderer) {
                _options.renderer = self.options.renderer
            }
            try {
                fetch(self.options.src, {method: 'get'})
                  .then(response => {
                    if (response.ok) {
                      return Promise.resolve(response);
                    }
                    else {
                      return Promise.reject(new Error('Failed to load'));
                    }
                  })
                  .then(response => {
                    return response.json();
                  })
                  .then(geojson => {
                    if (geojson.type == 'FeatureCollection') {
                        var _layer = L.geoJson(geojson, _options);
                        self.puton(_layer);
                    }
                  })
                  .catch(function(error) {
                    console.log("Error:" + error);
                  });
            }
            catch (e) {
                $.getJSON(self.options.src, {}).done(function(geojson) {
                    if (geojson.type == 'FeatureCollection') {
                        var _layer = L.geoJson(geojson, _options);
                        self.puton(_layer);
                    }
                }).fail(function( jqxhr, textStatus, error ) {
                    var err = textStatus + ", " + error;
                    console.log( "Request Failed: " + err );
                });
            }
        }
    }
});


L.BaseGeoJsonLayer = L.Layer.extend({
    options: {
        style: {
            color: 'rgb(20, 137, 113)',
            weight: 0.5,
            opacity: 1,
            fillColor: 'rgb(242, 229, 285)',
            fillOpacity: 1
        },
        layer_settings: {},
        pane: "tilePane"
    },

    initialize: function (options) {
        L.setOptions(this, options);
        this.layer_sets = {};
    },

    onAdd: function (map) {
        this._map = map;
        this._zoomChanged();

        map.on({
            'zoomend': this._zoomChanged
        }, this);
    },

    addTo: function (map) {
        map.addLayer(this);
        return this;
    },

    onRemove: function (map) {
        var layer_settings = this.options.layer_settings;
        for (var lyname in layer_settings) {
            var _layer = this.layer_sets[lyname];
            if (_layer) {
                this._map.removeLayer(_layer);
            }
        }
        this._map = null;

        map.off({
            'zoomend': this._zoomChanged
        }, this);
    },

    setStyle: function (style) {
        L.setOptions(this, style);

        return this;
    },

    redraw: function () {
        return this;
    },

    _zoomChanged: function() {
        if (!this._map) return;

        var zoom = this._map.getZoom(),
            layer_settings = this.options.layer_settings;
        for (var lyname in layer_settings) {
            var ly_setting = layer_settings[lyname];
            var _layer = this.layer_sets[lyname];

            if (ly_setting.zoom.start <= zoom && ly_setting.zoom.end >= zoom) {
                if (!_layer) {
                    _layer = this.layer_sets[lyname] = this._createLayer(ly_setting);
                }
                this._map.addLayer(_layer);
                _layer.bringToBack();
            }
            else {
                if (_layer) {
                    this._map.removeLayer(_layer);
                }
            }
        }
    },

    _createLayer: function(layer_setting) {
        let _options = {
            src: layer_setting.src,
            style: this.options.style,
            pane: this.options.pane
        }
        if (this.options.renderer) {
            _options.renderer = this.options.renderer
        }
        return new L.GeoJsonLayer(_options);
    }

});

L.baseGeoJsonLayer = function (options) {
    return new L.BaseGeoJsonLayer(options);
};


}(this, document));



// WEBPACK FOOTER //
// ./src/assets/cb/leaflet/leaflet.BaseLayer-GeoJson.js